//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectBodyList.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Button",0,"SelectBodyList",0],[1,"ChangeRadius",0,"Expression",0],[0,"EditSizeChoice",1,0],[0,"Matrix",1,0],[0,"Origin",1,0],[0,"Type",1,0],[1,"UMaximum",0,"Expression",0],[1,"UMinimum",0,"Expression",0],[1,"VMaximum",0,"Expression",0],[1,"VMinimum",0,"Expression",0]],[],[]];
SPLM.Die.QuickBinderWrapBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.QuickBinderWrapBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.QuickBinderWrapBuilder.Types = Object.freeze({
    "Planar" : "Planar", "Cylindrical" : "Cylindrical", "Conical" : "Conical"});

SPLM.Die.QuickBinderWrapBuilder.EditSizeType = Object.freeze({
    "Radius" : "Radius", "Scale" : "Scale"});

export default SPLM;